module.exports = __webpack_public_path__ + "static/img/icon_camera.e091b0f0.svg";